import React, { useState } from "react";
import LoadingSpinner from "../partials/loading";
import { imageProvider } from "../providers/Image.Provider";
import auth from "../providers/Auth.Provider";
import { toast } from "react-toastify";
import Image from "../partials/Image";

const FileUpload = ({ onData, title = "Select Image", accept = "image/*", className = "" }) => {
    const [fileSelected, setFileSelected] = useState(null);
    const [loading, setLoading] = useState(false);

    const [path, setPath] = useState(null);

    const { GetToken, GetAuthenticatedStaff } = auth.authProvider;
    const { site } = GetToken() && GetAuthenticatedStaff();
    return (
        <div className="row">
            <div className="col-md-12 fade-in" style={{ marginBottom: "1.6em" }}>
                {/* Control */}
                <h5>{title}</h5>
                <button type="button" onClick={() => document.getElementById("control-file").click()} className={"mdl-button mdl-button--raised mdl-js-ripple-effect btn-circle" + className}>
                    <i className="material-icons text-primary">portrait</i> Choose File
                </button>

                <input
                    type="file"
                    id="control-file"
                    style={{ display: "none" }}
                    hidden
                    multiple={false}
                    accept={accept}
                    onChange={async (e) => {
                        if (e.target.files.length > 0) {
                            setFileSelected(e.target.files[0]);
                            setLoading(true);
                            try {
                                const cb = await imageProvider.Upload(site && site.id, e.target.files[0]);
                                setLoading(false);
                                setPath(cb.path);
                                onData(new UploadResult(cb));
                                toast.success(cb.message);
                            } catch (error) {
                                setLoading(false);
                                toast.error(error.message);
                            }
                        } else {
                            toast.warn("No File Selected!");
                        }
                    }}
                />
            </div>
            {fileSelected && (
                <div className="col-md-12 fade-in">
                    {/* Preview */}
                    <LoadingSpinner loading={loading} bar={true} />
                    <div>{path && <>{fileSelected.type.includes("image") && <Image width={100} height={100} alt="Preview" src={path} />}</>}</div>
                </div>
            )}
        </div>
    );
};

export default FileUpload;
class UploadResult {
    constructor(model) {
        this.message = model.message;
        this.path = model.path;
        this.filename = model.filename;
    }
}
